import { render, staticRenderFns } from "./DAssistanceSpectrumDiagramBox.vue?vue&type=template&id=899135b0&scoped=true&"
import script from "./DAssistanceSpectrumDiagramBox.vue?vue&type=script&lang=ts&"
export * from "./DAssistanceSpectrumDiagramBox.vue?vue&type=script&lang=ts&"
import style0 from "./DAssistanceSpectrumDiagramBox.vue?vue&type=style&index=0&id=899135b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899135b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VList,VListItem,VListItemTitle,VMenu,VRow})
